/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Tut_Combine_IntroInputs */

const en_pc_tut_combine_intro = /** @type {(inputs: Pc_Tut_Combine_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Links, form fields, layers and attachments all survive a combine or split.`)
};

const zh_pc_tut_combine_intro = /** @type {(inputs: Pc_Tut_Combine_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`合并或拆分后，链接、表单域、图层和附件都完整保留。`)
};

/**
* | output |
* | --- |
* | "Links, form fields, layers and attachments all survive a combine or split." |
*
* @param {Pc_Tut_Combine_IntroInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_tut_combine_intro = /** @type {((inputs?: Pc_Tut_Combine_IntroInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Tut_Combine_IntroInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_tut_combine_intro(inputs)
	return zh_pc_tut_combine_intro(inputs)
});
export { pc_tut_combine_intro as "pc.tut.combine.intro" }